// this file added by Bearer Web Developer
import { Menu, MenuItem } from "@mui/material";
import React from "react";
import styles from './themeMenu.module.scss';
import { ThemeMode, useThemeMode } from "../../../states/contexts/theme";

interface Props {
    anchorEl: HTMLElement | null
    handleClose: () => void
}

const ThemeMenu: React.FC<Props> = ({ anchorEl, handleClose }) => {

    const open = Boolean(anchorEl);
    const { theme, setThemeMode } = useThemeMode(); // added by Bearer Web Developer
    const handlClick = (theme_mode: ThemeMode | 'system') => {
        setThemeMode(theme_mode);
        handleClose();
    }
    return (
        <>
            <Menu
                disablePortal={true}
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    onMouseLeave: handleClose
                }}
                classes={{ paper: styles.paper }}
                style={{ top: "0px", borderRadius: "10px", paddingTop: 0,zIndex:1402 }}
                PaperProps={{
                    style: {
                        background: "var(--neutral-hsb-89, #E3E3E3)",
                        boxShadow: "0px 38px 31px -27px rgba(53, 53, 53, 0.37)",
                        position:"absolute",
                        zIndex:1402,
                    }
                }}
            >
                <div className={styles.theme_menu} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    <MenuItem style={{ padding: "0 14px" }} className={styles.menu_item} onClick={() => handlClick(ThemeMode.Light)}>
                        <span className={styles.text}>Light</span>
                    </MenuItem>
                    <MenuItem style={{ padding: "0 14px" }} className={styles.menu_item} onClick={() => handlClick(ThemeMode.Dark)}>
                        <span className={styles.text}>Dark</span>
                    </MenuItem>
                    <MenuItem style={{ padding: "0 14px" }} className={styles.menu_item} onClick={() => handlClick('system')}>
                        <span className={styles.text_end}>System</span>
                    </MenuItem>
                </div>
            </Menu>
        </>

    )
};
export default ThemeMenu;